import FormattedMessage from 'I18n/components/FormattedMessage';
import { useLocation } from 'react-router-dom';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { TASK_WRITE_SCOPES } from '../../constants/scopes';
import { useSelector } from '../../context/Redux';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useActiveViewId } from '../../hooks/viewTabs';
import { createHasOneOfScopesSelector } from '../../redux/selectors/auth';
import { createTaskLink } from '../../utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const hasCreateTaskScopeSelector = createHasOneOfScopesSelector(TASK_WRITE_SCOPES);
const CreateTaskButton = ({
  size = 'default',
  use = 'tertiary-light'
}) => {
  const hasCreateTaskScope = useSelector(hasCreateTaskScopeSelector);
  const tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "taskForm.createTaskUnauthorized"
  });
  const activeViewId = useActiveViewId();
  const {
    pathname
  } = useLocation();
  const queryParamsString = useQueryParamString();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: hasCreateTaskScope,
      title: tooltipTitle,
      placement: "bottom left",
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        use: use,
        size: size,
        to: `${createTaskLink(pathname, String(activeViewId))}${queryParamsString}`,
        disabled: !hasCreateTaskScope,
        "data-selenium-test": "create-task-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "taskForm.buttons.createTaskLabel"
        })
      })
    })
  });
};
export default CreateTaskButton;